import * as React from "react";
import { SVGProps } from "react";
const SvgSocialXing = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m22.585 8.972-4.79 8.47a.012.012 0 0 0-.002.006c0 .003 0 .005.002.007l3.05 5.572c.06.12.062.242.005.335-.056.09-.158.138-.287.138h-2.162c-.331 0-.497-.22-.604-.412l-3.074-5.64c.154-.27 4.814-8.536 4.814-8.536.116-.209.256-.412.579-.412h2.186c.13 0 .232.05.287.138.058.092.056.214-.004.334ZM12.358 19.016h-2.17a.31.31 0 0 1-.319-.321c0-.059.015-.117.044-.168l2.292-4.05c.003-.005.003-.01 0-.016l-1.467-2.537c-.06-.12-.056-.229 0-.32.055-.09.16-.139.29-.139h2.156c.332 0 .504.206.611.398l1.483 2.598-2.339 4.127c-.11.2-.257.428-.581.428ZM26 5H6a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgSocialXing;
